var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._v(" Vehicle Events = " + _vm._s(_vm.id) + " "),
    _vm.vehicleEvents
      ? _c(
          "ul",
          _vm._l(_vm.vehicleEvents.items, function(event) {
            return _c(
              "li",
              { key: event.id },
              [_c("VehicleEventsItem", { attrs: { event: event } })],
              1
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }